'use client';

import { __assign } from '../../../_virtual/_tslib.js';
import { ENotificationTypes } from '../../types.js';

var mapJobInvitationNotificationReducer = function (params) {
    var state = params.state, jobInvitations = params.jobInvitations;
    var jobInvitationNotifications = jobInvitations.map(function (item) {
        var _a, _b, _c, _d, _e;
        return ({
            notifyKey: "JI-".concat(item.id, "-").concat(item.jobId),
            companyLogo: (_a = item.companyLogo) !== null && _a !== void 0 ? _a : '',
            companyName: (_b = item.companyName) !== null && _b !== void 0 ? _b : '',
            employerId: -1,
            isAttached: -1,
            isRead: item.status,
            isShowLogo: 1,
            noOfEmployerViews: 0,
            resumeId: -1,
            sentDate: item.time,
            source: -1,
            statusId: "-1",
            type: ENotificationTypes.JOB_INVITATION,
            userId: -1,
            jobInvitationId: item.id,
            viewDate: item.time,
            jobTitle: (_c = item.jobTitle) !== null && _c !== void 0 ? _c : '',
            expiredDate: 0,
            aliasEn: '',
            aliasVi: '',
            alias: (_d = item.alias) !== null && _d !== void 0 ? _d : '',
            content: (_e = item.content) !== null && _e !== void 0 ? _e : ''
        });
    });
    return __assign(__assign({}, state), { jobInvitationNotifications: jobInvitationNotifications });
};

export { mapJobInvitationNotificationReducer };
//# sourceMappingURL=mapJobInvitationNotifications.js.map
